module.exports = __webpack_public_path__ + "static/media/logo-game-show.bc881931.png";